import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useEffect } from 'react';
import { getCurrentPosition, getTargetScrollPosition } from "./utils";
import { calculateBlurOffset } from "../useScrollBlur/utils";
export var useNavigationScroll = function useNavigationScroll(_ref) {
  var wrapperRef = _ref.wrapperRef,
    _ref$buttonScrollThro = _ref.buttonScrollThrough,
    buttonScrollThrough = _ref$buttonScrollThro === void 0 ? 'end' : _ref$buttonScrollThro,
    tabWidths = _ref.tabWidths,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'default' : _ref$position,
    _ref$activeIndex = _ref.activeIndex,
    activeIndex = _ref$activeIndex === void 0 ? 0 : _ref$activeIndex,
    setBlurOffset = _ref.setBlurOffset;
  var scrollToTargetPosition = useCallback(function (index) {
    var _tabWidths$slice, _wrapperRef$current, _wrapperRef$current2;
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left';
    // Вычисляем расстояние от начала до самого компонента
    var itemOffset = (tabWidths === null || tabWidths === void 0 ? void 0 : (_tabWidths$slice = tabWidths.slice(0, index)) === null || _tabWidths$slice === void 0 ? void 0 : _tabWidths$slice.reduce(function (acc, val) {
      return acc + val;
    }, 0)) || 0;
    // Подгоняем состояние блюра под позицию скролла
    var blurOffset = calculateBlurOffset(side === 'left' ? itemOffset : ((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.scrollLeft) || 0, wrapperRef, position);
    var left = getTargetScrollPosition(index, tabWidths || [], side, wrapperRef, blurOffset);
    (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.scrollTo({
      left: left,
      behavior: 'smooth'
    });
  }, [tabWidths, position]);
  useEffect(function () {
    // Проскраливаем до выбранного элемента когда выставились ширины элементов, ограничения для того чтобы не пытался проскролить к несущесвующему элементу
    if (tabWidths !== null && tabWidths !== void 0 && tabWidths.some(function (el) {
      return el > 0;
    }) && activeIndex >= 0 && activeIndex < tabWidths.length) {
      scrollToTargetPosition(activeIndex);
    }
  }, [activeIndex, tabWidths]);

  // Возвращаем колбек для навигации по кнопкам
  return useCallback(function (side) {
    return function () {
      var _wrapperRef$current4;
      // Если в настройках указано перемещение в конец, то сразу скроллим до крайних значений
      if (buttonScrollThrough === 'end') {
        var _wrapperRef$current3;
        (_wrapperRef$current3 = wrapperRef.current) === null || _wrapperRef$current3 === void 0 ? void 0 : _wrapperRef$current3.scrollTo({
          left: side === 'left' ? 0 : wrapperRef.current.scrollWidth,
          behavior: 'smooth'
        });
        return;
      }
      var blurOffset = calculateBlurOffset(((_wrapperRef$current4 = wrapperRef.current) === null || _wrapperRef$current4 === void 0 ? void 0 : _wrapperRef$current4.scrollLeft) || 0, wrapperRef, position);

      // Вычисляем индексы элементов которые находятся во вьюпорте слева и справа
      var targetPositions = getCurrentPosition(wrapperRef, tabWidths || [], blurOffset);

      // Определяем индекс элемента к которому будем скроллить
      var targetIndex = Math.min(Math.max(targetPositions[side] + buttonScrollThrough * (side === 'left' ? -1 : 1), 0), (tabWidths === null || tabWidths === void 0 ? void 0 : tabWidths.length) || 0);
      var isToEnd = side === 'left' ? targetIndex === 0 : targetIndex === ((tabWidths === null || tabWidths === void 0 ? void 0 : tabWidths.length) || 0) - 1;
      if (position === 'default') {
        setBlurOffset(function (prev) {
          var _objectSpread2;
          return _objectSpread(_objectSpread({}, prev), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, side === 'left' ? 'right' : 'left', side === 'left' ? 90 : 86), _defineProperty(_objectSpread2, side, isToEnd ? 0 : prev[side]), _objectSpread2));
        });
      }
      scrollToTargetPosition(targetIndex, side);
    };
  }, [buttonScrollThrough, tabWidths, scrollToTargetPosition]);
};